import React, {Component} from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
  } from 'reactstrap';
import {NavLink} from 'react-router-dom'
import Logo from '../../assets/logo.png'
import './Header.css'
import {connect} from 'react-redux'

const mapStateToProps=state=>{
    return{
        token:state.token
    }
}

class Header extends Component{
    state={
        isOpen:false,
    }
    
    toggle=()=>{
        this.setState(
            {
                isOpen:!this.state.isOpen
            }
        )
    }
    render(){
        // console.log(this.props);
        let links=null;
        if(this.props.token===null){
            links=(<Nav className="ml-auto" navbar>
                        <NavItem>
                        <NavLink className="Link ml-2 text-decoration-none" exact to="/auth">Sign Up</NavLink>
                        </NavItem>
                    </Nav>)
        }
        else{
            links=(<Nav className="ml-auto" navbar>
                <NavItem>
                    <NavLink className="Link ml-2 text-decoration-none" exact to="/">Burger Builder</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="Link ml-2 text-decoration-none" exact to="/order">Order</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className="Link ml-2 text-decoration-none" exact to="/logout">Logout</NavLink>
                </NavItem>
                </Nav>)
        }
        return(
            <div className="Navigation">
            <Navbar className="heading" expand="md">
                <div className="container">
                <NavbarBrand href="/" className="Brand">
                    <img src={Logo} alt="" width="80"/>
                </NavbarBrand>
                <NavbarToggler onClick={this.toggle} className="me-2 bg-light" />
                <Collapse isOpen={this.state.isOpen} navbar>
                    
                    {links}
                </Collapse>
                </div>
            </Navbar>
        </div>
        )
    }
}
export default connect(mapStateToProps)(Header);